/*
 * @Author: Enzo
 * @Date: 2021-07-21 10:15:28
 * @LastEditTime: 2021-07-21 19:18:27
 * @LastEditors: Enzo
 * @Description:
 * @FilePath: /waimai_cd_fe_greentech_c/src/components/UserData/index.js
 * God is watching you
 */
import React, { useCallback, useEffect } from 'react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { Loading } from '@roo/roo';
import {
  getUserData,
  getUserAgreement,
  getApplyFiles,
  getConf,
  getArticlesV2,
  ProjectTypeEnums,
} from '../../assets/apis/base';
import { setUserData } from './user';
import { getSimpleContext } from '../../pages/apply/_utils/simple';
import { sendPv } from '../../utils/lxUtils';
import { getSubject } from '../../assets/apis/scientist';
import { getAllReportDirec } from '../../assets/apis/innovate';

// const url = encodeURIComponent(
//   `http://greentech.waimai.test.sankuai.com/api/greentech/c/user/redirect?continue=${window.location.href}`,
// );
// const loginUrl = `http://passport.fe.st.sankuai.com/account/unitivelogin?service=d19a5bca&continue=${url}`;

const { Provider, useSimpleContext } = getSimpleContext({
  mtUid: '',
  roleType: '',
  userName: '',
  // 用户协议
  sign: '',
  // 用户协议  青山科技
  signSci: '',
  // 用户协议  环保创新项目
  signIno: '',
  load: false,
  frameUrl: '',
  articles: [],
  qingshan: { help: '', rule: '', faq: '' },
  kechuang: { help: '', rule: '', faq: '' },
  rule_update: { time: '', name: '' },
  // 申报截止时间以及当前时间
  timestamp: 0,
  endTimeSci: 0,
  endTimeIno: 0,
  // 相关文件下载链接
  kechuang_apply_file: '',
  qingshan_apply_file: '',
  kechuang_review_file: '',
  qingshan_review_file: '',
  // 是否已申报
  applyFlag: false,
});

export const useUserContext = useSimpleContext;
export const UserProvider = Provider;

export function useUserData() {
  const { state } = useUserContext((t) => [t.userName, t.sign, t.mtUid, t.roleType, t.load, t.frameUrl, t.applyFlag]);
  return {
    mtUid: String(state.mtUid),
    roleType: String(state.roleType),
    userName: state.userName,
    sign: String(state.sign),
    signJudge: state.signJudge,
    load: state.load,
    endTimeSci: state.endTimeSci,
    endTimeIno: state.endTimeIno,
    timestamp: state.timestamp,
    sciProjectConfigId: state.sciProjectConfigId,
    inoProjectConfigId: state.inoProjectConfigId,
    subjects: state.subjects,
    sub2: state.sub2,
    topics: state.topics,
    inoTopicList: state.inoTopicList,
    sciTopicList: state.sciTopicList,
    applyFlag: state.applyFlag,
    refreshUserData: state.refreshUserData,
  };
}

export function UserData(props) {
  const [loading, setLoading] = React.useState(true);
  const { update } = useUserContext();
  const history = useHistory();
  const path = history.location.pathname;

  const refreshUserData = useCallback(async () => {
    update((t) => {
      t.load = false;
    });
    setLoading(true);
    try {
      const conf = await getConf();
      const { timestamp, projectConfDto = [] } = conf || {};
      // 项目 id 可能变化，但是 type 不会变化
      const confSci = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.SciType);
      const confIno = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.InoType);
      const res = await getUserData();
      // 接口返回的roleType是数字
      const {
        mtUid, roleType, userName, applyFlag,
      } = res?.data || {};
      localStorage.setItem('greentech_roleType', roleType);
      localStorage.setItem('greentech_mtUid', mtUid);
      const [subjects, sub2, signSci, sciTopics, signInno, inoTopics] = await Promise.all([
        getSubject({ type: 1 }),
        getSubject(),
        ...(confSci ? [
          getUserAgreement({ projectConfigId: confSci?.id, type: roleType === 1 ? 'judge' : '' }),
          getAllReportDirec({ projectConfigId: confSci?.id }, 1),
        ] : [undefined, undefined]),
        ...(confIno ? [
          getUserAgreement({ projectConfigId: confIno?.id, type: roleType === 1 ? 'judge' : '' }),
          getAllReportDirec({ projectConfigId: confIno?.id }, 2),
        ] : [undefined, undefined]),
      ]);
      const sciTopicList = sciTopics?.directions || [];
      const inoTopicList = inoTopics?.directions || [];
      const signJudge = roleType === 1 && signSci?.mtUid;
      if (mtUid) {
        setUserData({
          mtUid,
          roleType,
          userName,
          sign: 'true',
          signIno: signInno?.mtUid ? 'true' : 'false',
          signSci: signSci?.mtUid ? 'true' : 'false',
          signJudge,
          subjects,
          sub2,
          sciTopicList,
          inoTopicList,
        });
        update((t) => {
          t.mtUid = mtUid;
          t.roleType = roleType;
          t.userName = userName;
          t.sign = signSci?.mtUid ? 'true' : 'false';
          t.signJudge = signJudge;
          t.load = true;
          t.timestamp = timestamp;
          t.endTimeSci = confSci?.applyEndTime;
          t.endTimeIno = confIno?.applyEndTime;
          t.sciProjectConfigId = confSci?.id;
          t.inoProjectConfigId = confIno?.id;
          t.subjects = subjects;
          t.sub2 = sub2;
          t.sciTopicList = sciTopicList;
          t.inoTopicList = inoTopicList;
          t.applyFlag = !!applyFlag;
        });
      }
      setLoading(false);
      sendPv(mtUid);
    } catch (error) {
      console.error('Error in refreshUserData:', error);
    } finally {
      setLoading(false);
      update((t) => {
        t.load = true;
      });
    }
  }, []);

  useEffect(() => {
    try {
      refreshUserData();
      update((t) => {
        t.refreshUserData = refreshUserData;
      });
    } catch (e) {
      console.log(e);
    }
  }, [refreshUserData]);

  useEffect(() => {
    const getArticlesFromConfig = getArticlesV2().then((data) => {
      const { list } = data;
      return list.map((item) => ({
        desc: item.overview,
        img: item.coverUrl,
        status: 'on',
        time: dayjs(item.time).format('YYYY-MM-DD'),
        title: item.title,
        url: item.textUrl,
        fromConfig: true,
      }));
    });
    getArticlesFromConfig.then((data) => {
      update((t) => {
        t.articles = data;
      });
    });
  }, []);

  useEffect(() => {
    getApplyFiles().then((data) => {
      update((t) => {
        t.qingshan.rule = data.qingshan_rule;
        t.qingshan.help = data.qingshan_help;
        t.qingshan.faq = data.qingshan_faq;
        t.kechuang.rule = data.kechuang_rule;
        t.kechuang.help = data.kechuang_help;
        t.kechuang.faq = data.kechuang_faq;
        t.rule_update = data.update;
        t.kechuang_apply_file = data.download_files?.kechuang_apply_file;
        t.kechuang_review_file = data.download_files?.kechuang_review_file;
        t.qingshan_apply_file = data.download_files?.qingshan_apply_file;
        t.qingshan_review_file = data.download_files?.qingshan_review_file;
      });
    });
  }, []);

  if (loading && !['/', '/home'].includes(path)) {
    return <Loading backdrop fullscreen visible={loading} />;
  }

  return props.children;
}
